export default __webpack_public_path__ + "static/media/leaderboard_button.a4231832.png";